module.exports = __webpack_public_path__ + "img/joinkuke.d8269167.png";